import Omni from './omni';
import { ToolAssistant35, ToolAssistant4 } from './tool-assistant';

export const getBuiltAgents = () => [
    Omni,
    ToolAssistant35,
    ToolAssistant4,
];